module.exports = __webpack_public_path__ + "img/resource-tech-image-60.e4512380.jpg";